<template>
  <!-- This example requires Tailwind CSS v2.0+ -->
<div class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <!--
      Background overlay, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

    <!-- This element is to trick the browser into centering the modal contents. -->
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <!--
      Modal panel, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->
    <div v-click-away="() => $emit('close')" class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full">
        <img src="/images/lcap-header-valet.jpg" alt="Image of a car being washed">
      <div class="px-4 pt-2 pb-3 sm:px-6 sm:pb-6">
        <div class="text-center sm:mt-5">
          <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">Need a valet?</h3>
          <div class="mt-2">
            <p class="text-sm text-gray-500">Why not come back to a sparkling clean car! We offer a Valet cleaning service for your car when you leave it at one of our Airport Carparks.</p>

            <div class="text-left mt-6" v-for="vehicle in vehicles" :key="vehicle.registration">
                {{ vehicle.registration }}
                <SelectDropdown
                    v-model:valet="vehicle.valet"

                    position="relative"
                    :options="vehicle.type.valets"
                ></SelectDropdown>
            </div>
          </div>
        </div>
      </div>
      <div class="m-5 sm:m-6 text-center">
        <button @click="$emit('close')" type="button" class="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm">Continue</button>
        <button @click="$emit('close')" class="text-gray-500 mt-4">No Thanks</button>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import SelectWithSupportText from '../SelectWithSupportText.vue';

export default {
    emits: ['update:vehicles', 'close'],
    props: {
        open: { required: true },
        vehicles: { required: true },
    },
    components: {
        SelectDropdown: SelectWithSupportText,
    },
    watch: {
        vehicles(value) {
            this.$emit('update:vehicles', value);
        },
    },
};
</script>

<style>

</style>
